import { inject, injectable } from 'inversify';
import type { ClientSeasonRepositoryInterface } from '@client/entity/client-season/domain/repository/client-season.repository';
import { dispatchAuthenticationRequiredOnApiError } from '@shared/common/network/data/service/dispatch-authentication-required-on-api-error.service';
import { ClientSeasonDependencyTypes } from '@client/entity/client-season/client-season.dependency-types';
import type { ClientSeasonApiService } from '@client/entity/client-season/data/service/client-season.api-service';
import type { ClientSeasonApiDataTransformer } from '@client/entity/client-season/data/transformer/client-season.api-data-transformer';
import type { ClientSeasonFillingRate } from '@client/entity/client-season/domain/model/client-season-filling-rate.model';

@injectable()
export class ClientSeasonRepository implements ClientSeasonRepositoryInterface {
  public constructor(
    @inject(ClientSeasonDependencyTypes.ClientSeasonApiService)
    private readonly apiService: ClientSeasonApiService,
    @inject(ClientSeasonDependencyTypes.ClientSeasonApiDataTransformer)
    private readonly apiDataTransformer: ClientSeasonApiDataTransformer,
  ) {}

  @dispatchAuthenticationRequiredOnApiError()
  public async fetchSubscriberProgress(clientId: string): Promise<ClientSeasonFillingRate | null> {
    const response = await this.apiService.getClientSeason(clientId);

    return this.apiDataTransformer.map(response.data);
  }
}
